/* eslint-disable max-len */
import React from 'react'
import { useAppTranslation } from '../../../../../hooks/useAppTranslation'
import { ErrorBoundary } from '../../../../../components/common/ErrorBoundary'
import { ViewBase } from '../../../../../components/common/ViewBase'
import { SAMFALLIGHETERNA_SCHOOL_COURSES_LINK } from '../../../../../constants/Links'
import { ManagementPartnerCard } from '../../../../../components/society/ManagementPartner/ManagementPartnerCard'
import { ManagementPartner } from '../../../../../components/society/ManagementPartner/management_partner'
import { ManagementPartnerBase } from '../../../../../components/society/ManagementPartner/ManagementPartnerBase'
import { useCurrentSociety } from '../../../../../hooks/useCurrentSociety'
import { useDocumentTitle } from '../../../../../hooks/useDocumentTitle'
import { reverseDocumentTitle } from '../../../../../navigation/reverseDocumentTitle'
import { i18nSocietyType } from '../../../../../i18n'

export const SamfalligheternaSchoolView = (): React.ReactNode => {
  const { translate } = useAppTranslation()
  const { society } = useCurrentSociety()
  useDocumentTitle(
    reverseDocumentTitle('management:samfalligheterna-school', {
      '{{ societyName }}': society?.name,
    })
  )

  return (
    <ErrorBoundary>
      <ViewBase
        title={translate('samfalligheterna.samfalligheternaSchoolView.title')}
      >
        <ManagementPartnerBase
          partner={ManagementPartner.VILLAAGARNA}
          description={translate(
            'samfalligheterna.samfalligheternaSchoolView.description',
            { context: i18nSocietyType(society?.societyTypeDisplayName) }
          )}
        >
          <ManagementPartnerCard
            url={SAMFALLIGHETERNA_SCHOOL_COURSES_LINK}
            title={translate(
              'samfalligheterna.samfalligheternaSchoolView.coursesTitle'
            )}
            text={translate(
              'samfalligheterna.samfalligheternaSchoolView.coursesText',
              { context: i18nSocietyType(society?.societyTypeDisplayName) }
            )}
          />
        </ManagementPartnerBase>
      </ViewBase>
    </ErrorBoundary>
  )
}
